/*
 * Scroll To Top
 - - - - - - - - - -
 Scrolls to the top of the page, smoothly or instantly.
 @param smooth - scroll behavior
 */
export const scrollToTop = (smooth = true) => {
  window.scrollTo({ top: 0, left: 0, behavior: smooth ? "smooth" : "auto" });
};
